import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { ViewportScroller } from '@angular/common';
import {
   Router,
   Event,
   NavigationStart,
   NavigationEnd,
   NavigationCancel,
   NavigationError,
   RouterOutlet,
   Scroll
} from '@angular/router'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { CommonService } from '@appShared/services/common.service'
import { UrlService } from '@appShared/services/url.service'
//import { HybridWebviewInteropService } from '@appShared/services/hybrid-webview-interop.service'

//declare let gtag: () => void

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
   private _commonService = inject(CommonService)
   private _urlService = inject(UrlService)
   private _viewportScroller = inject(ViewportScroller)
   private _ngDestroyed$ = new Subject();
   previousUrl = '';
   currentUrl = '';
   loading = false;
   showHeaderFooter = false;
   isIframe = false;

   constructor(
      /*injecting hybrid service so it will come alive as soon as angular starts */
      //hybridWebviewInteropService: HybridWebviewInteropService,
      router: Router
   ) {

      router.events
         .pipe(takeUntil(this._ngDestroyed$))
         .subscribe((routerEvent: Event) =>
            this._checkRouterEvent(routerEvent)
      )
      let x=25
   }

   ngOnInit(): void {
      this.isIframe = window !== window.parent && !window.opener
   }

   ngOnDestroy(): void {
      this._ngDestroyed$.next(true)
      this._ngDestroyed$.complete()
   }

   /*
    * private methods
    * */

   private _checkRouterEvent(routerEvent: Event): void {
      if (routerEvent instanceof NavigationStart) {
         this._commonService.setLoading(true)

         return
      }

      if (
         routerEvent instanceof NavigationEnd ||
         routerEvent instanceof NavigationError ||
         routerEvent instanceof NavigationCancel
      ) {
         this._commonService.setLoading(false)

         if (routerEvent instanceof NavigationEnd) {
            this.previousUrl = this.currentUrl
            this.currentUrl = routerEvent.url
            this._urlService.setPreviousUrl(this.previousUrl)

            /* gtag('config', 'UA-7880158-22', {
              page_path: routerEvent.urlAfterRedirects
            }); */
         }

         return
      }

      if (routerEvent instanceof Scroll) {
         // console.log('app-event', e);
         if (routerEvent.position) {
            // backward navigation
            this._viewportScroller.scrollToPosition(routerEvent.position)
         } else if (routerEvent.anchor) {
            // anchor navigation
            this._viewportScroller.scrollToAnchor(routerEvent.anchor)
         } else {
            // forward navigation
            this._viewportScroller.scrollToPosition([0, 0])
         }

         return
      }
   }
}
